const ALL = 'default';

export default function validateMetadata(metadata, definitions, onlyErrors = false) {
  const metadataWithRequired = Object.keys(metadata).reduce((res, lang) => {
    res[lang] = {
      ...Object.keys(definitions).map(key => definitions[key]).filter(d => d.required).reduce((acc, d) => {
        acc[d.name] = null;
        return acc;
      }, {}),
      ...metadata[lang],
      ...metadata[ALL],
    };
    return res;
  }, {});

  delete metadataWithRequired[ALL];
  return Object.keys(metadataWithRequired).reduce((res, lang) => {
    res[lang] = Object.keys(metadataWithRequired[lang]).reduce((mres, key) => {
      const data = metadataWithRequired[lang][key];
      const def = definitions[key];

      if (def && def.required && !data) {
        mres[key] = `Field "${def.title}" is required`;
      } else if (!onlyErrors) {
        mres[key] = null;
      }
      return mres;
    }, {});
    return res;
  }, {});
}
